import { render, staticRenderFns } from "./ReviewStudentTimes.vue?vue&type=template&id=4587f0b2&scoped=true&"
import script from "./ReviewStudentTimes.vue?vue&type=script&lang=js&"
export * from "./ReviewStudentTimes.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStudentTimes.vue?vue&type=style&index=0&id=4587f0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587f0b2",
  null
  
)

export default component.exports